import { Injectable } from "@angular/core";
import { IIsSoundEnabledService } from "@karma-games/angular-devkit/src/lib/modules/sound";
import { map, Observable } from "rxjs";
import { GetSoundsEnabledUseCase } from "@karma-games/angular-devkit/src/lib/modules/settings";

@Injectable({
    providedIn: "root"
})
export class ClientSoundService implements IIsSoundEnabledService {

    constructor(private getSoundsEnabledUseCase: GetSoundsEnabledUseCase) {
    }

    getIsSoundEnabled(): Observable<boolean> {
        return <Observable<boolean>> this.getSoundsEnabledUseCase.execute().pipe(map(result => result ?? false));
    }
}
